"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _repeatInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/repeat");

require("core-js/modules/es.function.name");

require("core-js/modules/es.number.constructor");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.replace");

require("core-js/modules/es.string.split");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.registerDate = exports.BmDate = void 0;

var _padStart = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/pad-start"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/keys"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));

var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/index-of"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/taggedTemplateLiteral"));

var _element = require("@onviobr/element");

var _bmSelect = require("./bm-select");

var _bmIcon = require("./bm-icon");

function _templateObject11() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t\t\t<option value\n\t\t\t\t\t?selected=", "\n\t\t\t\t\t?disabled=", ">\n\t\t\t\t</option>"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t\t\t<option\n\t\t\t\t\t.value=", "\n\t\t\t\t\t?disabled=", "\n\t\t\t\t\t?selected=", ">\n\t\t\t\t\t", "\n\t\t\t\t</option>"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t\t<div class=\"bm-date\">\n\t\t\t\t", "\n\t\t\t\t", "\n\t\t\t</div>\n\t\t"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = (0, _taggedTemplateLiteral2.default)(["<span class=\"separator\">", "</span>"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t\t<div class=\"fake-picker\">\n\t\t\t\t<input\n\t\t\t\t\ttype=\"date\"\n\t\t\t\t\tmin=", "\n\t\t\t\t\tmax=", "\n\t\t\t\t\t?disabled=", "\n\t\t\t\t\tvalue=", "\n\t\t\t\t\t@change=", " />\n\t\t\t\t<button\n\t\t\t\t\ttype=\"button\"\n\t\t\t\t\t?disabled=", ">\n\t\t\t\t\t<bm-icon type=\"Calendar\"></bm-icon>\n\t\t\t\t</button>\n\t\t\t</div>\n\t\t"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t\t<bm-select class=\"", "\"\n\t\t\t\t?large=", ">\n\t\t\t\t<select\n\t\t\t\t\tid=\"year\"\n\t\t\t\t\tname=\"", "\"\n\t\t\t\t\taria-label=\"", "\"\n\t\t\t\t\t?disabled=", "\n\t\t\t\t\taria-readonly=\"", "\"\n\t\t\t\t\tvalue=", "\n\t\t\t\t\t@change=", ">\n\t\t\t\t\t", "\n\t\t\t\t\t", "\n\t\t\t\t</select>\n\t\t\t</bm-select>\n\t\t"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t\t<bm-select class=\"", "\"\n\t\t\t\t?large=", ">\n\t\t\t\t<select\n\t\t\t\t\tid=\"month\"\n\t\t\t\t\tname=\"", "\"\n\t\t\t\t\taria-label=\"", "\"\n\t\t\t\t\t?disabled=", "\n\t\t\t\t\taria-readonly=\"", "\"\n\t\t\t\t\tvalue=", "\n\t\t\t\t\t@change=", ">\n\t\t\t\t\t", "\n\t\t\t\t\t", "\n\t\t\t\t</select>\n\t\t\t</bm-select>"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t\t<bm-select class=\"", "\"\n\t\t\t\t?large=", ">\n\t\t\t\t<select\n\t\t\t\t\tid=\"day\"\n\t\t\t\t\tname=\"", "\"\n\t\t\t\t\taria-label=\"", "\"\n\t\t\t\t\t?disabled=", "\n\t\t\t\t\taria-readonly=\"", "\"\n\t\t\t\t\tvalue=", "\n\t\t\t\t\t@change=", ">\n\t\t\t\t\t", "\n\t\t\t\t\t", "\n\t\t\t\t</select>\n\t\t\t</bm-select>"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t:host .fake-picker {\n\t\t\tposition: relative;\n\t\t\ttop: -4px;\n\t\t\tdisplay: inline-flex;\n\t\t\toverflow: hidden;\n\t\t}\n\n\t\t:host .fake-picker input {\n\t\t\tposition: absolute;\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t\topacity: 0;\n\t\t\tz-index: 2;\n\t\t\tbackground: transparent;\n\t\t\twidth: 200%;\n\t\t\tborder: 0;\n\t\t\tmargin: 0;\n\t\t}\n\t\t:host .fake-picker input:active,\n\t\t:host .fake-picker input:focus {\n\t\t\toutline: none;\n\t\t}\n\n\t\t:host .fake-picker input::-webkit-datetime-edit {\n\t\t\tdisplay: none;\n\t\t}\n\t\t:host .fake-picker input::-webkit-clear-button {\n\t\t\tdisplay: none;\n\t\t}\n\t\t:host .fake-picker input::-webkit-inner-spin-button {\n\t\t\tdisplay: none;\n\t\t}\n\t\t:host .fake-picker input::-webkit-calendar-picker-indicator {\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t\topacity: 0;\n\t\t}\n\n\t\t:host .fake-picker input:not(:disabled):not(.disabled),\n\t\t:host .fake-picker input:not(:disabled):not(.disabled) * {\n\t\t\tcursor: pointer;\n\t\t}\n\n\t\t:host .date-field select:disabled {\n\t\t\tcursor: not-allowed;\n\t\t}\n\n\t\t:host .fake-picker input:disabled {\n\t\t\tcursor: not-allowed;\n\t\t}\n\n\t\t:host .fake-picker button {\n\t\t\tbackground: 0 0;\n\t\t\tborder: none;\n\t\t\theight: 30px;\n\t\t\tpadding: 0;\n\t\t\twidth: 30px;\n\t\t\tborder-radius: 0;\n\t\t\tz-index: 1;\n\t\t}\n\t"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t:host([readonly]) bm-select.bm-readonly {\n\t\t\tbackground: initial;\n\t\t}\n\t\t:host([readonly]) bm-select.bm-readonly select {\n\t\t\tbackground: transparent;\n\t\t\tborder: none;\n\t\t\toutline: none;\n\t\t\tpadding: 0;\n\t\t}\n\n\t\t:host([readonly]) bm-select.bm-readonly select,\n\t\t:host([readonly]) bm-select.bm-readonly select option {\n\t\t\ttext-align: justify;\n\t\t\ttext-align-last: center;\n\t\t}\n\t\t:host([readonly]) bm-select.bm-readonly::after {\n\t\t\tdisplay: none;\n\t\t}\n\t\t:host([readonly]) bm-select.bm-readonly {\n\t\t\tmin-width: auto;\n\t\t\twidth: auto;\n\t\t}\n\t"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t:host {\n\t\t\tdisplay: inline-flex;\n\t\t\tflex-direction: column;\n\t\t\twidth: 100%;\n\t\t}\n\t\tbm-select.two-digits {\n\t\t\twidth: 55px;\n\t\t}\n\t\tbm-select.four-digits {\n\t\t\twidth: 73px;\n\t\t}\n\t\t.bm-date {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t}\n\t\t.bm-date bm-select:not(:first-child) {\n\t\t\tmargin-left: 4px;\n\t\t}\n\t\t.separator {\n\t\t\tmargin-left: 4px;\n\t\t}\n\t"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var DEFAULT_MIN = '1800-01-01';
var DEFAULT_MAX = '2099-12-31';
var styles = {
  selectStyles: (0, _element.css)(_templateObject()),
  selectReadonlyStyles: (0, _element.css)(_templateObject2()),
  fakePickerStyle: (0, _element.css)(_templateObject3())
};

var BmDate = /*#__PURE__*/function (_BlueElement) {
  (0, _inherits2.default)(BmDate, _BlueElement);

  var _super = (0, _createSuper2.default)(BmDate);

  (0, _createClass2.default)(BmDate, null, [{
    key: "properties",
    get: function get() {
      return {
        name: {
          type: String,
          attribute: false,
          reflect: false
        },
        day: {
          type: Number
        },
        month: {
          type: Number
        },
        year: {
          type: Number
        },
        value: {
          type: String,
          reflect: true
        },
        disabled: {
          type: Boolean
        },
        readonly: {
          type: Boolean,
          attribute: true,
          reflect: true
        },
        required: {
          type: Boolean
        },
        locale: {
          type: String
        },
        min: {
          type: String
        },
        max: {
          type: String
        },
        range: {
          type: String
        },
        large: {
          type: Boolean
        },
        showSeparators: {
          type: Boolean,
          attribute: true,
          reflect: true
        },
        separator: {
          type: String,
          attribute: false,
          reflect: false
        }
      };
    }
  }, {
    key: "is",
    get: function get() {
      return 'bm-date';
    }
  }, {
    key: "styles",
    get: function get() {
      return [styles.selectStyles, styles.selectReadonlyStyles];
    }
  }]);

  function BmDate() {
    var _this;

    (0, _classCallCheck2.default)(this, BmDate);
    _this = _super.call(this);
    _this.disabled = false;
    _this.readonly = false;
    _this.required = false;
    _this.showSeparators = false;
    _this.separator = '/';
    _this._min = void 0;
    _this._max = void 0;
    _this._min = _this._parseISODateToParts(DEFAULT_MIN);
    _this._max = _this._parseISODateToParts(DEFAULT_MAX);
    return _this;
  }

  (0, _createClass2.default)(BmDate, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var delimiter = 'item';
      var name = "".concat(this.name);
      var delimiterIndex = (0, _indexOf.default)(name).call(name, delimiter);
      var label = delimiterIndex !== -1 ? name.substring(0, delimiterIndex) : '';
      var monthLabel = label ? label + '-M' : '';
      var dayLabel = label ? label + '-D' : '';
      var yearLabel = label ? label + '-Y' : '';
      var dayInputClasses = (0, _element.classMap)({
        'two-digits': true,
        'bm-readonly': this.readonly
      });
      var dayInput = this.html(_templateObject4(), dayInputClasses, this.large, "".concat(this.name ? this.name.toString() + '-' : '', "day"), (0, _element.ifDefined)(dayLabel || undefined), this.disabled, this.readonly, this.day, this._datePartChanged, this._renderUnselected(this.day), this._renderDays());
      var monthInputClasses = (0, _element.classMap)({
        'two-digits': true,
        'bm-readonly': this.readonly
      });
      var monthInput = this.html(_templateObject5(), monthInputClasses, this.large, "".concat(this.name ? this.name.toString() + '-' : '', "month"), (0, _element.ifDefined)(monthLabel || undefined), this.disabled, this.readonly, this.month, this._datePartChanged, this._renderUnselected(this.month), this._renderMonths());
      var yearInputClasses = (0, _element.classMap)({
        'four-digits': true,
        'bm-readonly': this.readonly
      });
      var yearInput = this.html(_templateObject6(), yearInputClasses, this.large, "".concat(this.name ? this.name.toString() + '-' : '', "year"), (0, _element.ifDefined)(yearLabel || undefined), this.disabled, this.readonly, this.year, this._datePartChanged, this._renderUnselected(this.year), this._renderYears());
      var datePicker = this.html(_templateObject7(), this.min, this.max, this.disabled, this.value, this._dateSelected, this.disabled);

      var renderLocaleDate = function renderLocaleDate() {
        var withSeparators = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var localeDAte = _this2.locale === 'en-GB' ? [dayInput, monthInput, yearInput] : [monthInput, dayInput, yearInput];

        if (!withSeparators) {
          return localeDAte;
        }

        var dateWithSeparators = [localeDAte[0]];

        var separator = _this2.html(_templateObject8(), _this2.separator);

        for (var i = 1; i < localeDAte.length; ++i) {
          dateWithSeparators.push(separator);
          dateWithSeparators.push(localeDAte[i]);
        }

        return dateWithSeparators;
      };

      return this.html(_templateObject9(), renderLocaleDate(this.showSeparators || this.readonly), this._browserSupportsDatePicker() ? datePicker : undefined);
    }
  }, {
    key: "shouldUpdate",
    value: function shouldUpdate(changedProperties) {
      if (changedProperties.has('name')) {
        this._setRangeOfYears(this.name);
      }

      if (changedProperties.has('range')) {
        this.min = this._parseMinRange(this.range);
        this.max = this._parseMaxRange(this.range);
      }

      if (changedProperties.has('min')) {
        this._min = this._parseISODateToParts(this.min);
      }

      if (changedProperties.has('max')) {
        this._max = this._parseISODateToParts(this.max);
      }

      if (changedProperties.has('value') && !this._isPartialDate()) {
        this._updateDateParts(this.value);
      }

      return (0, _get2.default)((0, _getPrototypeOf2.default)(BmDate.prototype), "shouldUpdate", this).call(this, changedProperties);
    }
  }, {
    key: "_setRangeOfYears",
    value: function _setRangeOfYears(type) {
      var standardList = ['taxpayer-date-of-death', 'taxpayer-date-of-birth', 'dependent-date-of-birth', 'spouse-date-of-death', 'spouse-date-of-birth'];
      var driverLicenseList = ['taxpayer-expiration-date', 'taxpayer-issue-date', 'spouse-expiration-date', 'spouse-issue-date'];

      if ((0, _includes.default)(standardList).call(standardList, type)) {
        this._min = [new Date().getFullYear() - 110, 1, 1];
        this._max = [new Date().getFullYear(), 1, 1];
      }

      if ((0, _includes.default)(driverLicenseList).call(driverLicenseList, type)) {
        this._min = [new Date().getFullYear() - 20, 1, 1];
        this._max = [new Date().getFullYear() + 20, 1, 1];
      }
    }
  }, {
    key: "_renderOption",
    value: function _renderOption(option, selected) {
      var readonly = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      return this.html(_templateObject10(), option[1], readonly || option[0] < 0, option[1] === selected, option[1]);
    }
  }, {
    key: "_renderOptions",
    value: function _renderOptions(options, selected) {
      var _context,
          _this3 = this;

      var readonly = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var opts = (0, _map.default)(_context = options()).call(_context, function (n) {
        return [n, Math.abs(n)];
      });
      return (0, _repeatInstanceProperty(_element))(opts, function (n) {
        return n[0];
      }, function (option) {
        return _this3._renderOption(option, selected, readonly);
      });
    }
  }, {
    key: "_renderUnselected",
    value: function _renderUnselected(value) {
      if (this.readonly) {
        return null;
      }

      if (!this.required || !this.value) {
        return this.html(_templateObject11(), !value, this.required);
      }

      return null;
    }
  }, {
    key: "_renderDays",
    value: function _renderDays() {
      var _this4 = this;

      return this._renderOptions(function () {
        return _this4._days(_this4.month, _this4.year);
      }, this.day, this.readonly);
    }
  }, {
    key: "_renderMonths",
    value: function _renderMonths() {
      var _this5 = this;

      return this._renderOptions(function () {
        return _this5._months(_this5.year);
      }, this.month, this.readonly);
    }
  }, {
    key: "_renderYears",
    value: function _renderYears() {
      var _this6 = this;

      return this._renderOptions(function () {
        return _this6._years();
      }, this.year, this.readonly);
    }
  }, {
    key: "_datePartChanged",
    value: function _datePartChanged(event) {
      this[event.target.id] = Number(event.target.value);

      this._updateValue();
    }
  }, {
    key: "_dateSelected",
    value: function _dateSelected(event) {
      this._updateDateParts(event.target.value);

      this._updateValue();
    }
  }, {
    key: "_updateDateParts",
    value: function _updateDateParts(value) {
      if (value) {
        var parsedDate = this._parseISODate(value);

        this.day = parsedDate.getDate();
        this.month = parsedDate.getMonth() + 1;
        this.year = parsedDate.getFullYear();
      }
    }
  }, {
    key: "_updateValue",
    value: function _updateValue() {
      var newValue = '';

      if (this.day && this.month && this.year) {
        newValue = this._convertToISODateString(this.day, this.month, this.year);
      }

      if (newValue !== this.value) {
        this.value = newValue;
        this.dispatchEvent(new CustomEvent('change', {
          detail: {
            value: this.value
          },
          bubbles: true,
          composed: true
        }));
      }
    }
  }, {
    key: "_isPartialDate",
    value: function _isPartialDate() {
      return !this.value && (!this.day || !this.month || !this.year) && (Boolean(this.day) || Boolean(this.month) || Boolean(this.year));
    }
  }, {
    key: "_days",
    value: function _days(month, year) {
      var _context2,
          _this7 = this;

      var daysInFebruary = function daysInFebruary() {
        return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0) ? 29 : 28;
      };

      var daysInOtherMonths = function daysInOtherMonths() {
        return month > 7 && month % 2 === 0 || month < 8 && !(month % 2 === 0) ? 31 : 30;
      };

      return (0, _map.default)(_context2 = this._range(month === 2 ? daysInFebruary() : daysInOtherMonths(), 1)).call(_context2, function (day) {
        return _this7._dayInRange(day, month, year) ? day : -day;
      });
    }
  }, {
    key: "_dayInRange",
    value: function _dayInRange(day, month, year) {
      var _this$_min = (0, _slicedToArray2.default)(this._min, 3),
          minYear = _this$_min[0],
          minMonth = _this$_min[1],
          minDay = _this$_min[2];

      var _this$_max = (0, _slicedToArray2.default)(this._max, 3),
          maxYear = _this$_max[0],
          maxMonth = _this$_max[1],
          maxDay = _this$_max[2];

      return !(year === minYear && month === minMonth && day < minDay || year === maxYear && month === maxMonth && day > maxDay);
    }
  }, {
    key: "_months",
    value: function _months(year) {
      var _context3,
          _this8 = this;

      return (0, _map.default)(_context3 = this._range(12, 1)).call(_context3, function (m) {
        return _this8._monthInRange(m, year) ? m : -m;
      });
    }
  }, {
    key: "_monthInRange",
    value: function _monthInRange(month, year) {
      return !(year === this._min[0] && month < this._min[1] || year === this._max[0] && month > this._max[1]);
    }
  }, {
    key: "_years",
    value: function _years() {
      var minYear = Number(this._min[0]);
      var maxYear = Number(this._max[0]);
      return this._range(maxYear - minYear + 1, minYear, 'desc');
    }
  }, {
    key: "_range",
    value: function _range(count) {
      var _context4, _context5, _context6, _context7;

      var start = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var order = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'asc';
      if (order === 'asc') return (0, _map.default)(_context4 = (0, _toConsumableArray2.default)((0, _keys.default)(_context5 = new Array(count)).call(_context5))).call(_context4, function (n) {
        return n + start;
      });
      return (0, _map.default)(_context6 = (0, _toConsumableArray2.default)((0, _keys.default)(_context7 = new Array(count)).call(_context7))).call(_context6, function (n) {
        return count + start - n - 1;
      });
    }
  }, {
    key: "_convertToISODateString",
    value: function _convertToISODateString(day, month, year) {
      var _context8, _context9;

      return (0, _concat.default)(_context8 = (0, _concat.default)(_context9 = "".concat(year, "-")).call(_context9, this._twoDigits(month), "-")).call(_context8, this._twoDigits(day));
    }
  }, {
    key: "_convertDateToISODateString",
    value: function _convertDateToISODateString(value) {
      return this._convertToISODateString(value.getDate(), value.getMonth() + 1, value.getFullYear());
    }
  }, {
    key: "_parseISODate",
    value: function _parseISODate(value) {
      var dateParts = this._parseISODateToParts(value);

      return new Date(dateParts[0], dateParts[1] - 1, Number(dateParts[2]));
    }
  }, {
    key: "_parseISODateToParts",
    value: function _parseISODateToParts(value) {
      var dateParts = value.split('-');
      return [Number(dateParts[0]), Number(dateParts[1]), Number(dateParts[2])];
    }
  }, {
    key: "_twoDigits",
    value: function _twoDigits(value) {
      var _context10;

      return (0, _padStart.default)(_context10 = String(value)).call(_context10, 2, '0');
    }
  }, {
    key: "_parseMinRange",
    value: function _parseMinRange(range) {
      var minRange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();

      var parsedRange = this._parseRange(range, '-');

      switch (parsedRange[0]) {
        case 'm':
          minRange.setDate(1);

          if (parsedRange.length > 1) {
            minRange.setMonth(minRange.getMonth() - Number(parsedRange.substring(1)));
          }

          break;

        case 'y':
          minRange.setMonth(0);
          minRange.setDate(1);

          if (parsedRange.length > 1) {
            minRange.setFullYear(minRange.getFullYear() - Number(parsedRange.substring(1)));
          }

          break;

        default:
          break;
      }

      return this._convertDateToISODateString(minRange);
    }
  }, {
    key: "_parseMaxRange",
    value: function _parseMaxRange(range) {
      var maxRange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();

      var parsedRange = this._parseRange(range, '+');

      switch (parsedRange[0]) {
        case 'm':
          if (parsedRange.length > 1) {
            maxRange.setMonth(maxRange.getMonth() + Number(parsedRange.substring(1)));
          }

          maxRange.setDate(this._days(maxRange.getMonth() + 1, maxRange.getFullYear()).length);
          break;

        case 'y':
          maxRange.setMonth(11);
          maxRange.setDate(31);

          if (parsedRange.length > 1) {
            maxRange.setFullYear(maxRange.getFullYear() + Number(parsedRange.substring(1)));
          }

          break;

        default:
          break;
      }

      return this._convertDateToISODateString(maxRange);
    }
  }, {
    key: "_parseRange",
    value: function _parseRange(range, direction) {
      var parts = range.replace('+-', direction);
      var parsedRange = parts.substring((0, _indexOf.default)(parts).call(parts, direction) + 1).split(/\+|-/)[0];
      return parsedRange.substr(parsedRange.length - 1, 1) + parsedRange.substring(0, parsedRange.length - 1);
    }
  }, {
    key: "_browserSupportsDatePicker",
    value: function _browserSupportsDatePicker() {
      return false;
    }
  }]);
  return BmDate;
}(_element.BlueElement);

exports.BmDate = BmDate;

var registerDate = function registerDate() {
  (0, _bmSelect.registerSelect)();
  (0, _bmIcon.registerIcon)();
  (0, _element.register)(BmDate);
};

exports.registerDate = registerDate;
